<template>
    <div dusk="SideControlPaginator">
        <button
            v-if="!currentPageIsFirstPage"
            dusk="PrevPageButton"
            class="SideControlPaginator__prev flatButton flatButton-unActive !absolute z-[55] flex w-14 items-center justify-center transition duration-150 ease-out active:-translate-x-3"
            :aria-label="localizations[lang].tooltips.prev"
            @click="goPrev"
        >
            <span class="pointer flex h-12 w-12 items-center justify-center rounded-lg bg-theme-icon-bg">
                <svg-icon icon="chevron-left" width="44px" height="44px"></svg-icon>
            </span>
        </button>
        <button
            v-if="!currentPageIsLastPage"
            dusk="NextPageButton"
            class="SideControlPaginator__next flatButton flatButton-unActive !absolute z-[55] flex w-14 items-center justify-center transition duration-150 ease-out active:translate-x-3"
            :aria-label="localizations[lang].tooltips.next"
            :disabled="isFxlLoading"
            @click="goNext"
        >
            <span class="pointer flex h-12 w-12 items-center justify-center rounded-lg bg-theme-icon-bg">
                <SimpleSpinner v-if="isFxlLoading" width="24" height="24" />
                <svg-icon v-else icon="chevron-right" width="44px" height="44px"></svg-icon>
            </span>
        </button>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import SimpleSpinner from '../Utilities/SimpleSpinner.vue';

export default {
    /**
     * The use of this div is for desktop, where arrows are used to navigate between pages.
     * On desktop, there is always space on the sides that does not interfere with text interaction.
     *
     * On mobile, the text often reaches the edges of the screen, and we are using `shouldPageTurn`
     * We must handle interactions carefully to avoid frustrating the user.
     */
    name: 'SideControlPaginator',
    components: { SimpleSpinner },
    computed: {
        ...mapState(['localizations', 'lang', 'isLoading', 'isFixedLayout']),
        ...mapGetters(['onlyDesktopVisible', 'currentPageIsFirstPage', 'currentPageIsLastPage']),
        isFxlLoading() {
            return this.isFixedLayout && this.isLoading && !this.currentPageIsLastPage;
        },
    },
    methods: {
        ...mapActions(['goToPrevPage', 'goToNextPage']),
        ...mapMutations(['setSelectionInProgress', 'hideSelectionTool']),
        goNext() {
            this.resetValidSelection();
            this.goToNextPage();
        },
        goPrev() {
            this.resetValidSelection();
            this.goToPrevPage();
        },
        resetValidSelection() {
            this.setSelectionInProgress({ selectionInProgress: false });
            this.hideSelectionTool();
        },
    },
};
</script>

<style>
/* Sidebar offset support for navigation arrows */
.SideControlPaginator__prev {
    left: calc(var(--sidebar-offset-left, 0px) + 0.25rem);
    top: var(--ReaderHeaderHeight, 0px);
    height: calc(100% - var(--ReaderHeaderHeight, 0px));
    transition: left 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.SideControlPaginator__next {
    right: calc(var(--sidebar-offset-right, 0px) + 0.25rem);
    top: var(--ReaderHeaderHeight, 0px);
    height: calc(100% - var(--ReaderHeaderHeight, 0px));
    transition: right 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@media screen and (max-width: 570px) {
    .SideControlPaginator__prev {
        left: 0;
    }

    .SideControlPaginator__next {
        right: 0;
    }
}
</style>
